var map, marker;
var markers = new Array();
var showroomList = []; // new
var showroomStateList = []; // new
var storelist = new Array();
var stateList = new Array();
var focusedTile = "storeTile0";
var storeContainer = document.getElementById("storeListContainer");
var dataContainer = $("#storeListContainer");

// Dynamically Adding and ID attr to each store and increments by one. starts at 1
stores.forEach((store, index) => (store.id = index + 1));

// Initializing Map
function initMap() {
  var bounds = new google.maps.LatLngBounds();
  map = new google.maps.Map(document.getElementById("map"), {
    zoom: 4,
    center: {
      lat: 35.991314,
      lng: -86.593597,
    },
  });
  var geocoder = new google.maps.Geocoder();

  document.getElementById("submit").addEventListener("click", function () {
    geocodeAddress(geocoder, map);
  });
  document.getElementById("address").addEventListener("keyup", function () {
    if (event.keyCode === 13) {
      geocodeAddress(geocoder, map);
    }
  });
  var infowindow = new google.maps.InfoWindow();
  var i, y;
  for (i = 0; i < stores.length; i++) {
    if (stores[i].showroom == "Fake1") {
      marker = new google.maps.Marker({
        position: {
          lat: stores[i].lat,
          lng: stores[i].lon,
        },
        map: map,
        description: stores[i].showroom,
        id: i,
        icon: {
          url: "https://maps.google.com/mapfiles/ms/icons/red-dot.png",
        },
      });
    } else if (stores[i].showroom == "Fake2") {
      marker = new google.maps.Marker({
        position: {
          lat: stores[i].lat,
          lng: stores[i].lon,
        },
        map: map,
        description: stores[i].showroom,
        id: i,
        icon: {
          url: "https://maps.google.com/mapfiles/ms/icons/blue-dot.png",
        },
      });
    } else if (stores[i].showroom == "Fake3") {
      marker = new google.maps.Marker({
        position: {
          lat: stores[i].lat,
          lng: stores[i].lon,
        },
        map: map,
        description: stores[i].showroom,
        id: i,
        icon: {
          url: "https://maps.google.com/mapfiles/ms/icons/green-dot.png",
        },
      });
    } else {
      marker = new google.maps.Marker({
        position: {
          lat: stores[i].lat,
          lng: stores[i].lon,
        },
        map: map,
        description: stores[i].showroom,
        id: i,
        icon: {
          url: "https://maps.google.com/mapfiles/ms/icons/pink-dot.png",
        },
      });
    }
    markers[i] = marker;
    bounds.extend(marker.position);
    if (stores[i].storelink == "none") {
      google.maps.event.addListener(
        marker,
        "click",
        (function (marker, i) {
          return function () {
            infowindow.setContent(
              '<div class="mapInfo"><p style="margin-bottom: 5px;"><b>' +
                stores[i].showroom +
                '</b></p><p style="margin: 8px 0px 2px 4px;line-height:20px;">' +
                stores[i].street +
                "<br>" +
                stores[i].city +
                ", " +
                stores[i].state +
                " " +
                stores[i].zip +
                '</p><p style="margin: 8px 0px 2px 4px;line-height:20px;">Phone: ' +
                stores[i].phone +
                "<br>Email: " +
                stores[i].email +
                '<br><a style="margin: 8px 0px 2px 0px;text-decoration:underline;font-weight:600;" target="_blank" href="https://maps.google.com?saddr=Current+Location&daddr=' +
                stores[i].street +
                "," +
                stores[i].city +
                "," +
                stores[i].state +
                "," +
                stores[i].zip +
                '">Get Directions</a></p><p><b>COMING SOON</b></p></div>'
            );
            infowindow.open(map, this);
          };
        })(marker, i)
      );
    } else {
      /*
      ! pins that are on the map
      */
      if (stores[i].sNote == "none") {
        google.maps.event.addListener(
          marker,
          "click",
          (function (marker, i) {
            return function () {
              infowindow.setContent(
                '<div class="mapInfo"><p style="margin-bottom: 5px;"><b>' +
                  stores[i].showroom +
                  '</b></p><p style="margin: 8px 0px 2px 4px;line-height:20px;">' +
                  stores[i].street +
                  "<br>" +
                  stores[i].city +
                  ", " +
                  stores[i].state +
                  " " +
                  stores[i].zip +
                  '</p><p style="margin: 8px 0px 2px 4px;line-height:20px;">Phone: ' +
                  stores[i].phone +
                  "<br>Email: " +
                  stores[i].email +
                  '<br><a style="margin: 8px 0px 2px 0px;text-decoration:underline;font-weight:600;" target="_blank" href="https://maps.google.com?saddr=Current+Location&daddr=' +
                  stores[i].street +
                  "," +
                  stores[i].city +
                  "," +
                  stores[i].state +
                  "," +
                  stores[i].zip +
                  '">Get Directions</a></p><p style="margin: 15px 0px 15px 0px;"></p>"' +
                  /**
                   *  This adds the addStore to all the loctaions on the map
                   *
                   */
                  '<button style="width:100%; margin: 2.5px auto;" class="addStore" data-internalid=' +
                  stores[i].internalId +
                  " data-phone=" +
                  encodeURIComponent(stores[i].phone) +
                  " data-street=" +
                  encodeURIComponent(stores[i].street) +
                  " data-city=" +
                  encodeURIComponent(stores[i].city) +
                  " data-state=" +
                  stores[i].state +
                  " data-zip=" +
                  stores[i].zip +
                  " data-email=" +
                  stores[i].email +
                  "> Add store to form</button></div></div>"
              );
              infowindow.open(map, this);
            };
          })(marker, i)
        );
      } else {
        google.maps.event.addListener(
          marker,
          "click",
          (function (marker, i) {
            return function () {
              infowindow.setContent(
                '<div class="mapInfo"><p style="margin-bottom: 5px;"><b>' +
                  stores[i].showroom +
                  '</b></p><p style="margin: 8px 0px 2px 4px;line-height:20px;">' +
                  stores[i].street +
                  "<br>" +
                  stores[i].city +
                  ", " +
                  stores[i].state +
                  " " +
                  stores[i].zip +
                  '</p><p style="margin: 8px 0px 2px 4px;line-height:20px;">Phone: ' +
                  stores[i].phone +
                  "<br>Email: " +
                  stores[i].email +
                  '<br><a style="margin: 8px 0px 2px 0px;text-decoration:underline;font-weight:600;" target="_blank" href="https://maps.google.com?saddr=Current+Location&daddr=' +
                  stores[i].street +
                  "," +
                  stores[i].city +
                  "," +
                  stores[i].state +
                  "," +
                  stores[i].zip +
                  '">Get Directions</a></p><p style="margin: 15px 0px 15px 0px;"></p><h5 style="font-size: 15px; text-align: left;">' +
                  stores[i].sNote +
                  "</h5></div>" +
                  /**
                   *  This adds the addStore to all the loctaions on the map
                   * ! not sure when this shows but has been added and should work
                   */
                  '<button class=" addStore" data-internalid=' +
                  stores[i].internalId +
                  " data-phone=" +
                  encodeURIComponent(stores[i].phone) +
                  " data-street=" +
                  encodeURIComponent(stores[i].street) +
                  " data-city=" +
                  encodeURIComponent(stores[i].city) +
                  " data-state=" +
                  stores[i].state +
                  " data-zip=" +
                  stores[i].zip +
                  " data-email=" +
                  stores[i].email +
                  "> Add store to form </button></div></div>"
              );
              infowindow.open(map, this);
            };
          })(marker, i)
        );
      }
    }
    var showroomText;
    if (stores[i].zip == "10021") {
      showroomText =
        'Visit our showroom located in <a href="https://gracioushome.com/kitchens-1/" target="_blank">Gracious Home</a> to meet with a design expert.<br><span style="color:#b73093;">Now offering custom closets with FREE in-home design.</span><div style="margin:10px;"><p style="text-align:center;margin-bottom: -20px;color:#b73093"><b style="color:#b73093;">Showroom Located Inside</b></p><a href="https://gracioushome.com" target="_blank"><img style="max-width: 400px;margin: 20px 0px;clear: both;display: block;" src="https://cdn.shopify.com/s/files/1/0196/2351/0078/files/2016-GH-Logo-Tannin-Horizontal-1160x185.jpg?v=1578595829" /></a></div>';
    } else if (stores[i].zip == "77090" || stores[i].zip == "77031") {
      //showroomText = 'Stop by and meet one of our Kitchen Experts or call or email to setup an appointment.<br>Now offering phone and live online consultation, call or email today to setup an appointment.<br><span style="color:#b73093;">Now offering custom closets with FREE in-home design.</span>';
      showroomText =
        'Call or email one of our Kitchen Experts at this showroom to setup an in-person, telephone, or live video appointment.<br><span style="color:#b73093;">Now offering custom closets with FREE in-home design.</span>';
    } else {
      //showroomText = "Stop by and meet one of our Kitchen Experts or call or email to setup an appointment.<br>Now offering phone and live online consultation, call or email today to setup an appointment.";
      showroomText =
        "Call or email one of our Kitchen Experts at this showroom to setup an in-person, telephone, or live video appointment.";
    }

    if (
      stores[i].zip == "33009" ||
      stores[i].zip == "34112" ||
      stores[i].zip == "32837" ||
      stores[i].zip == "30062" ||
      stores[i].zip == "46241" ||
      stores[i].zip == "02184" ||
      stores[i].zip == "07662" ||
      stores[i].zip == "10021" ||
      stores[i].zip == "38464" ||
      stores[i].zip == "77031" ||
      stores[i].zip == "77090" ||
      stores[i].zip == "23230" ||
      stores[i].zip == "97015" ||
      stores[i].zip == "93003" ||
      stores[i].zip == "33009" ||
      stores[i].zip == "34112" ||
      stores[i].zip == "29418" ||
      stores[i].zip == "07047" ||
      stores[i].zip == "60169" ||
      stores[i].zip == "78751" ||
      stores[i].zip == "38464" ||
      stores[i].zip == "32503" ||
      stores[i].zip == "07662" ||
      stores[i].zip == "23230" ||
      stores[i].zip == "01545" ||
      stores[i].zip == "33710" ||
      stores[i].zip == "33143" ||
      stores[i].zip == "70815" ||
      stores[i].zip == "32401" ||
      stores[i].zip == "23602" ||
      stores[i].zip == "37067" ||
      stores[i].zip == "22079"
    ) {
      showroomText =
        showroomText +
        '<br><a href="https://cabinetstogo.com/pages/custom-built-cabinets" class="ghccBadge"><img src="https://cdn.shopify.com/s/files/1/0196/2351/0078/files/GHCCbadge.png?v=1578595702" /></a>';
    }

    if (stores[i].zip == "75074" || stores[i].zip == "75062") {
      showroomText =
        showroomText +
        '<br><a href="https://cabinetstogodev.myshopify.com/pages/installation" class="InHomeBadge"><img src="https://cdn.shopify.com/s/files/1/0196/2351/0078/files/CBGO0169_L2sp_InHome_Consult_Van.jpg?v=1597678150" /></a>';
    }
  }
  map.fitBounds(bounds);
}

// Function to use to group objects with same value
function groupArrayOfObjects(list, key) {
  return list.reduce(function (rv, x) {
    (rv[x[key]] = rv[x[key]] || []).push(x);
    return rv;
  }, {});
}

var groupStates = groupArrayOfObjects(stores, "state");
//!-------------Main list when page first loads of all the stores----------
for (var key in groupStates) {
  if (groupStates.hasOwnProperty(key)) {
    showroomStateList = `<h1 class="showRoomStateTitle">${key}</h1>`;
    dataContainer.append(showroomStateList);
    var obj = groupStates[key];
    for (var prop in obj) {
      if (obj.hasOwnProperty(prop)) {
        var secondObj = obj[prop];
        var showrooms = secondObj.showroom;
        var urlPath = secondObj.storelink;
        showroomList =
          '<div class="storeTiles"><div class="tileHeader"><div class="state" style="">' +
          showrooms +
          "</div>" +
          /**
           *  This is where all of the info is passed to the form.
           *  phone, street and city all need to be encoded because of spaces
           */
          '<button class=" addStore" data-internalid=' +
          secondObj.internalId +
          " data-phone=" +
          encodeURIComponent(secondObj.phone) +
          " data-street=" +
          encodeURIComponent(secondObj.street) +
          " data-city=" +
          encodeURIComponent(secondObj.city) +
          " data-state=" +
          secondObj.state +
          " data-zip=" +
          secondObj.zip +
          " data-email=" +
          secondObj.email +
          "> Add store to form</button></div></div>";
        dataContainer.append(showroomList);

        //onclick add to form
        // $(document).on("click", ".addStore1", function () {
        //   console.log(obj[prop].nsID);
        // });
      }
    }
  }
}

function deg2rad(deg) {
  return deg * (Math.PI / 180);
}

function calcDist(lat, loc) {
  var R = 3959; // mi
  var key = 0;
  var closestStores = [
    {
      dist: 0,
      ind: -1,
    },
  ];
  var lat1 = lat;
  var lon1 = loc;

  for (x = 0; x < stores.length; x++) {
    var dLat = deg2rad(stores[x].lat - lat1);
    var dLon = deg2rad(stores[x].lon - lon1);
    var a =
      Math.sin(dLat / 2) * Math.sin(dLat / 2) +
      Math.cos(deg2rad(lat1)) *
        Math.cos(deg2rad(stores[x].lat)) *
        Math.sin(dLon / 2) *
        Math.sin(dLon / 2);

    var c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
    var d = R * c; // Distance in mi
    if (d < 601) {
      if (closestStores[0].ind == -1) {
        closestStores[0].dist = d;
        closestStores[0].ind = x;
        //console.log(closestStores[0]);
      } else {
        for (var i = 0; i < closestStores.length; i++) {
          if (d < closestStores[i].dist) {
            closestStores.splice(i, 0, {
              dist: d,
              ind: x,
            });
            break;
          }
        }
      }
    }
  }
  return closestStores;
}

function setSearchMarkers(clStores, lat, lng) {
  storeContainer.innerHTML = "";
  if (clStores[0].ind == -1) {
    alert("No stores found within 500 miles of that address");
  } else {
    var bounds = new google.maps.LatLngBounds();
    var points = 0;
    var userMarker;
    storeContainer.innerHTML = "";

    for (var i = 0; i < markers.length; i++) {
      markers[i].setMap(null);
    }

    userMarker = new google.maps.Marker({
      map: map,
      position: {
        lat: lat,
        lng: lng,
      },
    });

    markers.push(userMarker);
    bounds.extend(userMarker.position);
    for (var st in groupStates) {
      if (groupStates.hasOwnProperty(st)) {
        var obj = groupStates[st];
        for (p in obj) {
          if (obj.hasOwnProperty(p)) {
            var secondObj = obj[p];
            var showrooms = secondObj.showroom;
            var urlPath = secondObj.storelink;
            if (clStores[0].ind === secondObj["id"] - 1) {
              /* 
              ! Creates store tiles after search by address/zip 
              */
              headerText = '<h1 class="showRoomStateTitle">Closest Store</h1>';
              showroomList =
                '<div class="storeTiles"><div class="tileHeader"><div style="">' +
                showrooms +
                '</div><div style="font-size:16px; font-weight:800"></div>' +
                '<button class=" addStore" data-internalid=' +
                secondObj.internalId +
                " data-phone=" +
                encodeURIComponent(secondObj.phone) +
                " data-street=" +
                encodeURIComponent(secondObj.street) +
                " data-city=" +
                encodeURIComponent(secondObj.city) +
                " data-state=" +
                secondObj.state +
                " data-zip=" +
                secondObj.zip +
                " data-email=" +
                secondObj.email +
                "> Add store to form</button></div></div>";

              noticeText = "<p>View Map for other possible locations.</p>";

              dataContainer.append(headerText + showroomList + noticeText);
            }
            for (var c = 0; c < clStores.length; c++) {
              markers[clStores[c].ind].setMap(map);
              bounds.extend(markers[clStores[c].ind].position);
              points++;
            }
          }
        }
      }
    }

    if (points > 1) {
      map.fitBounds(bounds);
    } else if (points == 1) {
      map.setCenter(bounds.getCenter());
      map.setZoom(17);
    }
  }
}

function geocodeAddress(geocoder, resultsMap) {
  var address = document.getElementById("address").value;
  geocoder.geocode(
    {
      address: address,
    },
    function (results, status) {
      if (status === "OK") {
        var lat = results[0].geometry.location.lat();
        var lng = results[0].geometry.location.lng();
        setSearchMarkers(calcDist(lat, lng), lat, lng);
      } else {
        alert(
          "Address not found, please use a valid U.S. Zip Code, City, State or Address"
        );
      }
    }
  );
}
/* 
! this is the by state filter

 */
function setStateMarkers(key) {
  var bounds = new google.maps.LatLngBounds();
  var points = 0;
  storeContainer.innerHTML = "";
  for (var i = 0; i < stores.length; i++) {
    if (stores[i].state == key) {
      markers[i].setMap(map);
      bounds.extend(markers[i].position);
      showroomList =
        '<div class="storeTiles" style="" id="storeTile' +
        i +
        '"><div class="tileHeader"><div style="">' +
        stores[i].showroom +
        '</div><div style="font-size:16px; font-weight:800"></div>' +
        '<button class="addStore" data-internalid=' +
        stores[i].internalId +
        " data-phone=" +
        encodeURIComponent(stores[i].phone) +
        " data-street=" +
        encodeURIComponent(stores[i].street) +
        " data-city=" +
        encodeURIComponent(stores[i].city) +
        " data-state=" +
        stores[i].state +
        " data-zip=" +
        stores[i].zip +
        " data-email=" +
        stores[i].email +
        "> Add store to form</button></div></div>";
      dataContainer.append(showroomList);
      points++;
    } else if (key == "all") {
      location.reload();
    } else {
      markers[i].setMap(null);
    }
  }
  if (points > 1) {
    map.fitBounds(bounds);
  } else if (points == 1) {
    map.setCenter(bounds.getCenter());
    map.setZoom(17);
  }
}

function highlightTile(t) {
  document.getElementById(focusedTile).style.borderColor = "rgba(0,0,0,0.2)";
  document.getElementById("storeTile" + t).style.borderColor =
    "rgba(255,200,255,0.4)";
  focusedTile = "storeTile" + t;
}
